
export const allCountries = [
    {
        label: 'Andorra',
        phone: '+376',
        flag: 'https://flagsapi.com/AD/flat/64.png'
    },
    {
        label: 'United Arab Emirates',
        phone: '+971',
        flag: 'https://flagsapi.com/AE/flat/64.png'
    },
    {
        label: 'Afghanistan',
        phone: '+93',
        flag: 'https://flagsapi.com/AF/flat/64.png'
    },
    {
        label: 'Anguilla',
        phone: '+1-264',
        flag: 'https://flagsapi.com/AI/flat/64.png'
    },
    {
        label: 'Albania',
        phone: '+355',
        flag: 'https://flagsapi.com/AL/flat/64.png'
    },
    {
        label: 'Armenia',
        phone: '+374',
        flag: 'https://flagsapi.com/AM/flat/64.png'
    },
    {
        label: 'Angola',
        phone: '+244',
        flag: 'https://flagsapi.com/AO/flat/64.png'
    },
    {
        label: 'Antarctica',
        phone: '+672',
        flag: 'https://flagsapi.com/AQ/flat/64.png'
    },
    {
        label: 'Argentina',
        phone: '+54',
        flag: 'https://flagsapi.com/AR/flat/64.png'
    },
    {
        label: 'American Samoa',
        phone: '+1-684',
        flag: 'https://flagsapi.com/AS/flat/64.png'
    },
    {
        label: 'Austria',
        phone: '+43',
        flag: 'https://flagsapi.com/AT/flat/64.png'
    },
    {
        label: 'Australia',
        phone: '+61',
        flag: 'https://flagsapi.com/AU/flat/64.png'
    },
    {
        label: 'Aruba',
        phone: '+297',
        flag: 'https://flagsapi.com/AW/flat/64.png'
    },
    {
        label: 'Azerbaijan',
        phone: '+994',
        flag: 'https://flagsapi.com/AZ/flat/64.png'
    },
    {
        label: 'Bahrain',
        phone: '+973',
        flag: 'https://flagsapi.com/BH/flat/64.png'
    },
    {
        label: 'Barbados',
        phone: '+1-246',
        flag: 'https://flagsapi.com/BB/flat/64.png'
    },
    {
        label: 'Bangladesh',
        phone: '+880',
        flag: 'https://flagsapi.com/BD/flat/64.png'
    },
    {
        label: 'Belgium',
        phone: '+32',
        flag: 'https://flagsapi.com/BE/flat/64.png'
    },
    {
        label: 'Burkina Faso',
        phone: '+226',
        flag: 'https://flagsapi.com/BF/flat/64.png'
    },
    {
        label: 'Bulgaria',
        phone: '+359',
        flag: 'https://flagsapi.com/BG/flat/64.png'
    },
    {
        label: 'Burundi',
        phone: '+257',
        flag: 'https://flagsapi.com/BI/flat/64.png'
    },
    {
        label: 'Benin',
        phone: '+229',
        flag: 'https://flagsapi.com/BJ/flat/64.png'
    },
    {
        label: 'Bermuda',
        phone: '+1-441',
        flag: 'https://flagsapi.com/BM/flat/64.png'
    },
    {
        label: 'Bolivia',
        phone: '+591',
        flag: 'https://flagsapi.com/BO/flat/64.png'
    },
    {
        label: 'Brazil',
        phone: '+55',
        flag: 'https://flagsapi.com/BR/flat/64.png'
    },
    {
        label: 'Bahamas',
        phone: '+1-242',
        flag: 'https://flagsapi.com/BS/flat/64.png'
    },
    {
        label: 'Bhutan',
        phone: '+975',
        flag: 'https://flagsapi.com/BT/flat/64.png'
    },
    {
        label: 'Bouvet Island',
        phone: '+47',
        flag: 'https://flagsapi.com/BV/flat/64.png'
    },
    {
        label: 'Botswana',
        phone: '+267',
        flag: 'https://flagsapi.com/BW/flat/64.png'
    },
    {
        label: 'Belarus',
        phone: '+375',
        flag: 'https://flagsapi.com/BY/flat/64.png'
    },
    {
        label: 'Belize',
        phone: '+501',
        flag: 'https://flagsapi.com/BZ/flat/64.png'
    },
    {
        label: 'Canada',
        phone: '+1',
        flag: 'https://flagsapi.com/CA/flat/64.png'
    },
    {
        label: 'Cocos (Keeling) Islands',
        phone: '+61',
        flag: 'https://flagsapi.com/CC/flat/64.png'
    },
    {
        label: 'Central African Republic',
        phone: '+236',
        flag: 'https://flagsapi.com/CF/flat/64.png'
    },
    {
        label: 'Switzerland',
        phone: '+41',
        flag: 'https://flagsapi.com/CH/flat/64.png'
    },
    {
        label: 'Cook Islands',
        phone: '+682',
        flag: 'https://flagsapi.com/CK/flat/64.png'
    },
    {
        label: 'Chile',
        phone: '+56',
        flag: 'https://flagsapi.com/CL/flat/64.png'
    },
    {
        label: 'Cameroon',
        phone: '+237',
        flag: 'https://flagsapi.com/CM/flat/64.png'
    },
    {
        label: 'China',
        phone: '+86',
        flag: 'https://flagsapi.com/CN/flat/64.png'
    },
    {
        label: 'Colombia',
        phone: '+57',
        flag: 'https://flagsapi.com/CO/flat/64.png'
    },
    {
        label: 'Costa Rica',
        phone: '+506',
        flag: 'https://flagsapi.com/CR/flat/64.png'
    },
    {
        label: 'Cuba',
        phone: '+53',
        flag: 'https://flagsapi.com/CU/flat/64.png'
    },
    {
        label: 'Cape Verde',
        phone: '+238',
        flag: 'https://flagsapi.com/CV/flat/64.png'
    },
    {
        label: 'Christmas Island',
        phone: '+61',
        flag: 'https://flagsapi.com/CX/flat/64.png'
    },
    {
        label: 'Cyprus',
        phone: '+357',
        flag: 'https://flagsapi.com/CY/flat/64.png'
    },
    {
        label: 'Germany',
        phone: '+49',
        flag: 'https://flagsapi.com/DE/flat/64.png'
    },
    {
        label: 'Djibouti',
        phone: '+253',
        flag: 'https://flagsapi.com/DJ/flat/64.png'
    },
    {
        label: 'Denmark',
        phone: '+45',
        flag: 'https://flagsapi.com/DK/flat/64.png'
    },
    {
        label: 'Dominica',
        phone: '+1-767',
        flag: 'https://flagsapi.com/DM/flat/64.png'
    },
    {
        label: 'Dominican Republic',
        phone: '+1-809',
        flag: 'https://flagsapi.com/DO/flat/64.png'
    },
    {
        label: 'Algeria',
        phone: '+213',
        flag: 'https://flagsapi.com/DZ/flat/64.png'
    },
    {
        label: 'Ecuador',
        phone: '+593',
        flag: 'https://flagsapi.com/EC/flat/64.png'
    },
    {
        label: 'Estonia',
        phone: '+372',
        flag: 'https://flagsapi.com/EE/flat/64.png'
    },
    {
        label: 'Egypt',
        phone: '+20',
        flag: 'https://flagsapi.com/EG/flat/64.png'
    },
    {
        label: 'Western Sahara',
        phone: '+212',
        flag: 'https://flagsapi.com/EH/flat/64.png'
    },
    {
        label: 'Eritrea',
        phone: '+291',
        flag: 'https://flagsapi.com/ER/flat/64.png'
    },
    {
        label: 'Spain',
        phone: '+34',
        flag: 'https://flagsapi.com/ES/flat/64.png'
    },
    {
        label: 'Ethiopia',
        phone: '+251',
        flag: 'https://flagsapi.com/ET/flat/64.png'
    },
    {
        label: 'Finland',
        phone: '+358',
        flag: 'https://flagsapi.com/FI/flat/64.png'
    },
    {
        label: 'Fiji',
        phone: '+679',
        flag: 'https://flagsapi.com/FJ/flat/64.png'
    },
    {
        label: 'Faroe Islands',
        phone: '+298',
        flag: 'https://flagsapi.com/FO/flat/64.png'
    },
    {
        label: 'France',
        phone: '+33',
        flag: 'https://flagsapi.com/FR/flat/64.png'
    },
    {
        label: 'Gabon',
        phone: '+241',
        flag: 'https://flagsapi.com/GA/flat/64.png'
    },
    {
        label: 'United Kingdom',
        phone: '+44',
        flag: 'https://flagsapi.com/GB/flat/64.png'
    },
    {
        label: 'Grenada',
        phone: '+1-473',
        flag: 'https://flagsapi.com/GD/flat/64.png'
    },
    {
        label: 'Georgia',
        phone: '+995',
        flag: 'https://flagsapi.com/GE/flat/64.png'
    },
    {
        label: 'French Guiana',
        phone: '+594',
        flag: 'https://flagsapi.com/GF/flat/64.png'
    },
    {
        label: 'Guernsey',
        phone: '+44',
        flag: 'https://flagsapi.com/GG/flat/64.png'
    },
    {
        label: 'Ghana',
        phone: '+233',
        flag: 'https://flagsapi.com/GH/flat/64.png'
    },
    {
        label: 'Gibraltar',
        phone: '+350',
        flag: 'https://flagsapi.com/GI/flat/64.png'
    },
    {
        label: 'Greenland',
        phone: '+299',
        flag: 'https://flagsapi.com/GL/flat/64.png'
    },
    {
        label: 'Gambia',
        phone: '+220',
        flag: 'https://flagsapi.com/GM/flat/64.png'
    },
    {
        label: 'Guinea',
        phone: '+224',
        flag: 'https://flagsapi.com/GN/flat/64.png'
    },
    {
        label: 'Guadeloupe',
        phone: '+590',
        flag: 'https://flagsapi.com/GP/flat/64.png'
    },
    {
        label: 'Equatorial Guinea',
        phone: '+240',
        flag: 'https://flagsapi.com/GQ/flat/64.png'
    },
    {
        label: 'Greece',
        phone: '+30',
        flag: 'https://flagsapi.com/GR/flat/64.png'
    },
    {
        label: 'Guatemala',
        phone: '+502',
        flag: 'https://flagsapi.com/GT/flat/64.png'
    },
    {
        label: 'Guam',
        phone: '+1-671',
        flag: 'https://flagsapi.com/GU/flat/64.png'
    },
    {
        label: 'Guinea-Bissau',
        phone: '+245',
        flag: 'https://flagsapi.com/GW/flat/64.png'
    },
    {
        label: 'Guyana',
        phone: '+592',
        flag: 'https://flagsapi.com/GY/flat/64.png'
    },
    {
        label: 'Honduras',
        phone: '+504',
        flag: 'https://flagsapi.com/HN/flat/64.png'
    },
    {
        label: 'Croatia',
        phone: '+385',
        flag: 'https://flagsapi.com/HR/flat/64.png'
    },
    {
        label: 'Haiti',
        phone: '+509',
        flag: 'https://flagsapi.com/HT/flat/64.png'
    },
    {
        label: 'Hungary',
        phone: '+36',
        flag: 'https://flagsapi.com/HU/flat/64.png'
    },
    {
        label: 'Indonesia',
        phone: '+62',
        flag: 'https://flagsapi.com/ID/flat/64.png'
    },
    {
        label: 'Ireland',
        phone: '+353',
        flag: 'https://flagsapi.com/IE/flat/64.png'
    },
    {
        label: 'Israel',
        phone: '+972',
        flag: 'https://flagsapi.com/IL/flat/64.png'
    },
    {
        label: 'Isle of Man',
        phone: '+44',
        flag: 'https://flagsapi.com/IM/flat/64.png'
    },
    {
        label: 'India',
        phone: '+91',
        flag: 'https://flagsapi.com/IN/flat/64.png'
    },
    {
        label: 'British Indian Ocean Territory',
        phone: '+246',
        flag: 'https://flagsapi.com/IO/flat/64.png'
    },
    {
        label: 'Iraq',
        phone: '+964',
        flag: 'https://flagsapi.com/IQ/flat/64.png'
    },
    {
        label: 'Iceland',
        phone: '+354',
        flag: 'https://flagsapi.com/IS/flat/64.png'
    },
    {
        label: 'Italy',
        phone: '+39',
        flag: 'https://flagsapi.com/IT/flat/64.png'
    },
    {
        label: 'Jersey',
        phone: '+44',
        flag: 'https://flagsapi.com/JE/flat/64.png'
    },
    {
        label: 'Jamaica',
        phone: '+1-876',
        flag: 'https://flagsapi.com/JM/flat/64.png'
    },
    {
        label: 'Jordan',
        phone: '+962',
        flag: 'https://flagsapi.com/JO/flat/64.png'
    },
    {
        label: 'Japan',
        phone: '+81',
        flag: 'https://flagsapi.com/JP/flat/64.png'
    },
    {
        label: 'Kenya',
        phone: '+254',
        flag: 'https://flagsapi.com/KE/flat/64.png'
    },
    {
        label: 'Kyrgyzstan',
        phone: '+996',
        flag: 'https://flagsapi.com/KG/flat/64.png'
    },
    {
        label: 'Kuwait',
        phone: '+965',
        flag: 'https://flagsapi.com/KW/flat/64.png'
    },
    {
        label: 'Cambodia',
        phone: '+855',
        flag: 'https://flagsapi.com/KH/flat/64.png'
    },
    {
        label: 'Kiribati',
        phone: '+686',
        flag: 'https://flagsapi.com/KI/flat/64.png'
    },
    {
        label: 'Comoros',
        phone: '+269',
        flag: 'https://flagsapi.com/KM/flat/64.png'
    },
    {
        label: 'Cayman Islands',
        phone: '+1-345',
        flag: 'https://flagsapi.com/KY/flat/64.png'
    },
    {
        label: 'Kazakhstan',
        phone: '+7',
        flag: 'https://flagsapi.com/KZ/flat/64.png'
    },
    {
        label: 'Lebanon',
        phone: '+961',
        flag: 'https://flagsapi.com/LB/flat/64.png'
    },
    {
        label: 'Liechtenstein',
        phone: '+423',
        flag: 'https://flagsapi.com/LI/flat/64.png'
    },
    {
        label: 'Sri Lanka',
        phone: '+94',
        flag: 'https://flagsapi.com/LK/flat/64.png'
    },
    {
        label: 'Liberia',
        phone: '+231',
        flag: 'https://flagsapi.com/LR/flat/64.png'
    },
    {
        label: 'Lesotho',
        phone: '+266',
        flag: 'https://flagsapi.com/LS/flat/64.png'
    },
    {
        label: 'Lithuania',
        phone: '+370',
        flag: 'https://flagsapi.com/LT/flat/64.png'
    },
    {
        label: 'Luxembourg',
        phone: '+352',
        flag: 'https://flagsapi.com/LU/flat/64.png'
    },
    {
        label: 'Latvia',
        phone: '+371',
        flag: 'https://flagsapi.com/LV/flat/64.png'
    },
    {
        label: 'Libya',
        phone: '+218',
        flag: 'https://flagsapi.com/LY/flat/64.png'
    },
    {
        label: 'Morocco',
        phone: '+212',
        flag: 'https://flagsapi.com/MA/flat/64.png'
    },
    {
        label: 'Monaco',
        phone: '+377',
        flag: 'https://flagsapi.com/MC/flat/64.png'
    },
    {
        label: 'Montenegro',
        phone: '+382',
        flag: 'https://flagsapi.com/ME/flat/64.png'
    },
    {
        label: 'Madagascar',
        phone: '+261',
        flag: 'https://flagsapi.com/MG/flat/64.png'
    },
    {
        label: 'Marshall Islands',
        phone: '+692',
        flag: 'https://flagsapi.com/MH/flat/64.png'
    },
    {
        label: 'Mali',
        phone: '+223',
        flag: 'https://flagsapi.com/ML/flat/64.png'
    },
    {
        label: 'Mongolia',
        phone: '+976',
        flag: 'https://flagsapi.com/MN/flat/64.png'
    },
    {
        label: 'Northern Mariana Islands',
        phone: '+1-670',
        flag: 'https://flagsapi.com/MP/flat/64.png'
    },
    {
        label: 'Martinique',
        phone: '+596',
        flag: 'https://flagsapi.com/MQ/flat/64.png'
    },
    {
        label: 'Mauritania',
        phone: '+222',
        flag: 'https://flagsapi.com/MR/flat/64.png'
    },
    {
        label: 'Montserrat',
        phone: '+1-664',
        flag: 'https://flagsapi.com/MS/flat/64.png'
    },
    {
        label: 'Malta',
        phone: '+356',
        flag: 'https://flagsapi.com/MT/flat/64.png'
    },
    {
        label: 'Mauritius',
        phone: '+230',
        flag: 'https://flagsapi.com/MU/flat/64.png'
    },
    {
        label: 'Maldives',
        phone: '+960',
        flag: 'https://flagsapi.com/MV/flat/64.png'
    },
    {
        label: 'Malawi',
        phone: '+265',
        flag: 'https://flagsapi.com/MW/flat/64.png'
    },
    {
        label: 'Mexico',
        phone: '+52',
        flag: 'https://flagsapi.com/MX/flat/64.png'
    },
    {
        label: 'Malaysia',
        phone: '+60',
        flag: 'https://flagsapi.com/MY/flat/64.png'
    },
    {
        label: 'Mozambique',
        phone: '+258',
        flag: 'https://flagsapi.com/MZ/flat/64.png'
    },
    {
        label: 'Namibia',
        phone: '+264',
        flag: 'https://flagsapi.com/NA/flat/64.png'
    },
    {
        label: 'New Caledonia',
        phone: '+687',
        flag: 'https://flagsapi.com/NC/flat/64.png'
    },
    {
        label: 'Niger',
        phone: '+227',
        flag: 'https://flagsapi.com/NE/flat/64.png'
    },
    {
        label: 'Norfolk Island',
        phone: '+672',
        flag: 'https://flagsapi.com/NF/flat/64.png'
    },
    {
        label: 'Nigeria',
        phone: '+234',
        flag: 'https://flagsapi.com/NG/flat/64.png'
    },
    {
        label: 'Nicaragua',
        phone: '+505',
        flag: 'https://flagsapi.com/NI/flat/64.png'
    },
    {
        label: 'Netherlands',
        phone: '+31',
        flag: 'https://flagsapi.com/NL/flat/64.png'
    },
    {
        label: 'Norway',
        phone: '+47',
        flag: 'https://flagsapi.com/NO/flat/64.png'
    },
    {
        label: 'Qatar',
        phone: '+974',
        flag: 'https://flagsapi.com/QA/flat/64.png'
    },
    {
        label: 'Nepal',
        phone: '+977',
        flag: 'https://flagsapi.com/NP/flat/64.png'
    },
    {
        label: 'Nauru',
        phone: '+674',
        flag: 'https://flagsapi.com/NR/flat/64.png'
    },
    {
        label: 'Niue',
        phone: '+683',
        flag: 'https://flagsapi.com/NU/flat/64.png'
    },
    {
        label: 'New Zealand',
        phone: '+64',
        flag: 'https://flagsapi.com/NZ/flat/64.png'
    },
    {
        label: 'Oman',
        phone: '+968',
        flag: 'https://flagsapi.com/OM/flat/64.png'
    },
    {
        label: 'Panama',
        phone: '+507',
        flag: 'https://flagsapi.com/PA/flat/64.png'
    },
    {
        label: 'Peru',
        phone: '+51',
        flag: 'https://flagsapi.com/PE/flat/64.png'
    },
    {
        label: 'French Polynesia',
        phone: '+689',
        flag: 'https://flagsapi.com/PF/flat/64.png'
    },
    {
        label: 'Papua New Guinea',
        phone: '+675',
        flag: 'https://flagsapi.com/PG/flat/64.png'
    },
    {
        label: 'Philippines',
        phone: '+63',
        flag: 'https://flagsapi.com/PH/flat/64.png'
    },
    {
        label: 'Pakistan',
        phone: '+92',
        flag: 'https://flagsapi.com/PK/flat/64.png'
    },
    {
        label: 'Poland',
        phone: '+48',
        flag: 'https://flagsapi.com/PL/flat/64.png'
    },
    {
        label: 'Puerto Rico',
        phone: '+1',
        flag: 'https://flagsapi.com/PR/flat/64.png'
    },
    {
        label: 'Portugal',
        phone: '+351',
        flag: 'https://flagsapi.com/PT/flat/64.png'
    },
    {
        label: 'Palau',
        phone: '+680',
        flag: 'https://flagsapi.com/PW/flat/64.png'
    },
    {
        label: 'Paraguay',
        phone: '+595',
        flag: 'https://flagsapi.com/PY/flat/64.png'
    },
    {
        label: 'Romania',
        phone: '+40',
        flag: 'https://flagsapi.com/RO/flat/64.png'
    },
    {
        label: 'Serbia',
        phone: '+381',
        flag: 'https://flagsapi.com/RS/flat/64.png'
    },
    {
        label: 'Rwanda',
        phone: '+250',
        flag: 'https://flagsapi.com/RW/flat/64.png'
    },
    {
        label: 'Solomon Islands',
        phone: '+677',
        flag: 'https://flagsapi.com/SB/flat/64.png'
    },
    {
        label: 'Seychelles',
        phone: '+248',
        flag: 'https://flagsapi.com/SC/flat/64.png'
    },
    {
        label: 'Sudan',
        phone: '+249',
        flag: 'https://flagsapi.com/SD/flat/64.png'
    },
    {
        label: 'Sweden',
        phone: '+46',
        flag: 'https://flagsapi.com/SE/flat/64.png'
    },
    {
        label: 'Singapore',
        phone: '+65',
        flag: 'https://flagsapi.com/SG/flat/64.png'
    },
    {
        label: 'Slovenia',
        phone: '+386',
        flag: 'https://flagsapi.com/SI/flat/64.png'
    },
    {
        label: 'Slovakia',
        phone: '+421',
        flag: 'https://flagsapi.com/SK/flat/64.png'
    },
    {
        label: 'Sierra Leone',
        phone: '+232',
        flag: 'https://flagsapi.com/SL/flat/64.png'
    },
    {
        label: 'San Marino',
        phone: '+378',
        flag: 'https://flagsapi.com/SM/flat/64.png'
    },
    {
        label: 'Senegal',
        phone: '+221',
        flag: 'https://flagsapi.com/SN/flat/64.png'
    },
    {
        label: 'Somalia',
        phone: '+252',
        flag: 'https://flagsapi.com/SO/flat/64.png'
    },
    {
        label: 'Suriname',
        phone: '+597',
        flag: 'https://flagsapi.com/SR/flat/64.png'
    },
    {
        label: 'South Sudan',
        phone: '+211',
        flag: 'https://flagsapi.com/SS/flat/64.png'
    },
    {
        label: 'El Salvador',
        phone: '+503',
        flag: 'https://flagsapi.com/SV/flat/64.png'
    },
    {
        label: 'Chad',
        phone: '+235',
        flag: 'https://flagsapi.com/TD/flat/64.png'
    },
    {
        label: 'French Southern Territories',
        phone: '+262',
        flag: 'https://flagsapi.com/TF/flat/64.png'
    },
    {
        label: 'Togo',
        phone: '+228',
        flag: 'https://flagsapi.com/TG/flat/64.png'
    },
    {
        label: 'Thailand',
        phone: '+66',
        flag: 'https://flagsapi.com/TH/flat/64.png'
    },
    {
        label: 'Tajikistan',
        phone: '+992',
        flag: 'https://flagsapi.com/TJ/flat/64.png'
    },
    {
        label: 'Tokelau',
        phone: '+690',
        flag: 'https://flagsapi.com/TK/flat/64.png'
    },
    {
        label: 'Timor-Leste',
        phone: '+670',
        flag: 'https://flagsapi.com/TL/flat/64.png'
    },
    {
        label: 'Turkmenistan',
        phone: '+993',
        flag: 'https://flagsapi.com/TM/flat/64.png'
    },
    {
        label: 'Tunisia',
        phone: '+216',
        flag: 'https://flagsapi.com/TN/flat/64.png'
    },
    {
        label: 'Tonga',
        phone: '+676',
        flag: 'https://flagsapi.com/TO/flat/64.png'
    },
    {
        label: 'Turkey',
        phone: '+90',
        flag: 'https://flagsapi.com/TR/flat/64.png'
    },
    {
        label: 'Tuvalu',
        phone: '+688',
        flag: 'https://flagsapi.com/TV/flat/64.png'
    },
    {
        label: 'Ukraine',
        phone: '+380',
        flag: 'https://flagsapi.com/UA/flat/64.png'
    },
    {
        label: 'Uganda',
        phone: '+256',
        flag: 'https://flagsapi.com/UG/flat/64.png'
    },
    {
        label: 'United States',
        phone: '+1',
        flag: 'https://flagsapi.com/US/flat/64.png'
    },
    {
        label: 'Uruguay',
        phone: '+598',
        flag: 'https://flagsapi.com/UY/flat/64.png'
    },
    {
        label: 'Uzbekistan',
        phone: '+998',
        flag: 'https://flagsapi.com/UZ/flat/64.png'
    },
    {
        label: 'Saudi Arabia',
        phone: '+966',
        flag: 'https://flagsapi.com/SA/flat/64.png'
    },
    {
        label: 'Venezuela',
        phone: '+58',
        flag: 'https://flagsapi.com/VE/flat/64.png'
    },
    {
        label: 'Vietnam',
        phone: '+84',
        flag: 'https://flagsapi.com/VN/flat/64.png'
    },
    {
        label: 'Vanuatu',
        phone: '+678',
        flag: 'https://flagsapi.com/VU/flat/64.png'
    },
    {
        label: 'Samoa',
        phone: '+685',
        flag: 'https://flagsapi.com/WS/flat/64.png'
    },
    {
        label: 'Yemen',
        phone: '+967',
        flag: 'https://flagsapi.com/YE/flat/64.png'
    },
    {
        label: 'Mayotte',
        phone: '+262',
        flag: 'https://flagsapi.com/YT/flat/64.png'
    },
    {
        label: 'South Africa',
        phone: '+27',
        flag: 'https://flagsapi.com/ZA/flat/64.png'
    },
    {
        label: 'Zambia',
        phone: '+260',
        flag: 'https://flagsapi.com/ZM/flat/64.png'
    },
    {
        label: 'Zimbabwe',
        phone: '+263',
        flag: 'https://flagsapi.com/ZW/flat/64.png'
    },




];


// export const countries = [
//     { code: 'AE', label: 'United Arab Emirates', phone: '+971', mobileNoLength: 9 },
//     { code: 'OM', label: 'Oman', phone: '+968', mobileNoLength: 8 },
//     { code: 'BH', label: 'Bahrain', phone: '+973', mobileNoLength: 8 },
//     { code: 'QA', label: 'Qatar', phone: '+974', mobileNoLength: 8 },
//     { code: 'KW', label: 'Kuwait', phone: '+965', mobileNoLength: 8 },
//     { code: 'SA', label: 'Saudi Arabia', phone: '+966', mobileNoLength: 9 },
// ]